export const MenuKeys = [
  'profile',
  'dashboard',
  'conversations',
  'surveys',
  'work-orders',
  'documents',
  'company',
] as const;

export type MenuKey = (typeof MenuKeys)[number];
